var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tbmobile-menus"},[_c('p',{staticClass:"title"},[_vm._v("卡首屏系列")]),_c('menus-tag-lists',{attrs:{"route-type":1,"list":_vm.infoData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }